import SelectCustomBindings from './SelectCustomBindings.js';
import Calendar from './../calendar/Calendar.js';

export default new class SelectCustom {
    constructor() {
        new SelectCustomBindings(Calendar);
    }

};





// WEBPACK FOOTER //
// ./src/common/modules/select-custom/SelectCustom.js